/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_StaggeredInputs */



/**
* | output |
* | --- |
* | "How does staggered seating work for 6, 7, or 11 players?" |
*
* @param {Og_Faq_Q_StaggeredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_staggered = /** @type {((inputs?: Og_Faq_Q_StaggeredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_StaggeredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment fonctionne le placement échelonné pour 6, 7 ou 11 joueurs ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cómo funcionan los asientos escalonados para 6, 7 u 11 jugadores?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como funciona o assento escalonado para 6, 7 ou 11 jogadores?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come funziona la seduta sfalsata per 6, 7 o 11 giocatori?")
	return /** @type {LocalizedString} */ ("How does staggered seating work for 6, 7, or 11 players?")
});